document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector(`[action="/search"] [data-quick-search-input]`);
  if (!inputSearch) return;

  let debounceTimer;
  inputSearch.addEventListener("input", (e) => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event('scroll'));
    }, 300);
  });
});


(() => {
  setTimeout(() => {
    handleQuickView();
  }, 1000)
})();

function handleQuickView(){
  const targetNode = document.querySelector('.quick-product-modal__content');

  if (targetNode) {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === 'attributes' &&
          mutation.attributeName === 'class'
        ) {
          setTimeout(() => {
              window.dispatchEvent(new Event('scroll'));
          },1000)
        }
      }
    });
  
    const config = {
      attributes: true,
      attributeFilter: ['class'], 
    };
  
    observer.observe(targetNode, config);
  }
}